import React from "react";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";

const AppDownload = () => {
    const { t } = useTranslation();

    return (
        <>
            <section className="bannerAreaN whiteBackground BannerDeatils greyBackground position">
                <div className="detailsPageSection">
                    <img
                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1709807887/VantageFit/2023/background-new.webp"
                        alt="corporate wellness"
                        className="img-responsive"
                        width="1435"
                        height="500"
                    />
                </div>

                <div className="BannerContent singleHeading">
                    <div className="headingBannerM container customCampaignContainer text-left ">
                        <div className="row">
                            <div className="col-lg-12 col-xs-12 col-md-12 col-sm-12 text-center">
                                <h1>Vantage Fit</h1>
                                <p className="colorwhite hero-para font-weight-semibold no-br">
                                    <Trans>
                                        Your complete health companion.
                                    </Trans>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="pt-20">
                <section>
                    <div className="container custom-container">
                        {/* <!--download mob view starts--> */}
                        {/* <section className="mobileview ">
                            <div className="row d-flex align_items_center campaigncontainer">
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center campaignlpage title_default">
                                    <h4>
                                        <Trans>
                                            <span>Download the</span> Vantage
                                            Fit <span>app today!</span>
                                        </Trans>
                                    </h4>
                                </div>

                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 d-left campaignlpage textleft">
                                    <a
                                        id="playstorelink"
                                        href="https://play.google.com/store/apps/details?id=com.bargaintechnologies.vantagefit.v_fit&referrer=utm_source%3Dwalkfromhome%26utm_medium%3Dall%26utm_campaign%3Dwalk%2520from%2520home"
                                        target="_blank"
                                    >
                                        <img
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1580904957/VantageFit/website/googleplay.png"
                                            alt="appdownload"
                                            className="downloadlogo"
                                        />
                                    </a>
                                </div>
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 d-flex justify-content-center">
                                    <img
                                        width={200}
                                        height={200}
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1724754634/VantageFit/2024/Vantage_Fit_PlayStore.png"
                                    />
                                </div>

                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 d-left textright mt-5">
                                    <a
                                        id="ioslink"
                                        href="https://apps.apple.com/app/apple-store/id1393594182?pt=68111800&ct=Walk%20From%20Home&mt=8"
                                        target="_blank"
                                    >
                                        <img
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1580904957/VantageFit/website/appstore.png"
                                            alt="appdownload"
                                            className="downloadlogo"
                                        />
                                    </a>
                                </div>
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12  d-flex justify-content-center">
                                    <img
                                        width={200}
                                        height={200}
                                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1724754634/VantageFit/2024/Vantage_Fit_AppStore.png"
                                    />
                                </div>
                            </div>
                        </section> */}
                        {/* <!--download mob view ends--> */}

                        <section className="mob-space">
                            <section className="section_space ">
                                <div className="row d-flex align_items_center downloadAppcontainer">
                                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center campaignlpage title_default">
                                        <h4>
                                            <Trans>Download the <span className="red-font">Vantage Fit</span> app today!</Trans>
                                        </h4>
                                    </div>

                                    <div className="row mt-2 mt-lg-5">
                                        <div className="col-12 col-lg-6 d-flex justify-content-center">
                                            <div className="col-7 qr-download">
                                                <img
                                                    width={180}
                                                    height={180}
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1724754634/VantageFit/2024/Vantage_Fit_PlayStore.png"
                                                />

                                                <div className="w-100">
                                                    <a
                                                        id="playstorelink"
                                                        href="https://play.google.com/store/apps/details?id=com.bargaintechnologies.vantagefit.v_fit&referrer=utm_source%3Dwalkfromhome%26utm_medium%3Dall%26utm_campaign%3Dwalk%2520from%2520home"
                                                        target="_blank"
                                                        className="w-100 d-flex justify-content-center"
                                                    >
                                                        <img
                                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1724838954/VantageFit/2024/Google_play.png"
                                                            alt="appdownload"
                                                            className="downloadlogo"
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 d-flex justify-content-center mt-3 mt-lg-0">
                                            <div className="col-7 qr-download">
                                                <img
                                                    width={180}
                                                    height={180}
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1724754634/VantageFit/2024/Vantage_Fit_AppStore.png"
                                                />

                                                <div className="w-100">
                                                    <a
                                                        id="AppStoreLink"
                                                        href="https://apps.apple.com/in/app/vantage-fit/id1393594182"
                                                        target="_blank"
                                                        className="w-100 d-flex justify-content-center"
                                                    >
                                                        <img
                                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1724838954/VantageFit/2024/App_store.png"
                                                            alt="appdownload"
                                                            className="downloadlogo"
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className="row d-flex align_items_center downloadAppcontainer  mt-2 mt-lg-5">
                                <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center campaignlpage title_spc">
                                    <h4>
                                        <Trans>
                                            Start now with just two easy steps
                                        </Trans>
                                    </h4>
                                </div>
                            </div>

                            <div className="row downloadAppcontainer mt-2 mt-lg-5">
                                <div className="col-12 col-md-6  row d-flex  defaultspc title_spc">
                                    <div className="col-lg-3 col-md-3 col-xs-3 col-sm-3 d-left campaignlpage text-center fadeInLeft wow imagelogoleft">
                                        <img
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1724838952/VantageFit/2024/Step1.png"
                                            alt="logimobile"
                                            className="img-responsive "
                                        />
                                    </div>

                                    <div className="col-lg-9 col-md-9 col-xs-9 col-sm-9 d-left wow fadeInRight imagelogoright">
                                        <p
                                            style={{
                                                fontWeight: 500,
                                            }}
                                        >
                                            <Trans>Step 1</Trans>
                                        </p>
                                        <p className="hero-para font-weight-semibold no-br">
                                            <Trans>
                                                Download the Vantage Fit app
                                                from Google PlayStore for
                                                Android or App Store for iOS.
                                            </Trans>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6  row d-flex  defaultspc">
                                    <div className="col-lg-3 col-md-3 col-xs-3 col-sm-3 d-left campaignlpage text-center wow fadeInLeft imagelogoleft">
                                        <img
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1724838953/VantageFit/2024/Step_2.png"
                                            alt="logimobile"
                                            className="img-responsive "
                                        />
                                    </div>

                                    <div className="col-lg-9 col-md-9 col-xs-9 col-sm-9 d-left wow fadeInRight imagelogoright">
                                        <p
                                            style={{
                                                fontWeight: 500,
                                            }}
                                        >
                                            <Trans>Step 2</Trans>
                                        </p>
                                        <p className="hero-para font-weight-semibold no-br">
                                            <Trans>
                                                Sign in with your corporate
                                                e-mail address.
                                            </Trans>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>
                {/* <!--last section--> */}
                <section className="new_footer_area pt-5">
                    <div className="row d-flex align_items_center ">
                        <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center ">
                            <h4
                                className="text-white"
                                style={{
                                    fontSize: 42,
                                    fontWeight: 400,
                                    lineHeight: "px",
                                }}
                            >
                                <Trans>So what are you waiting for?</Trans>
                            </h4>
                            <p className="text-white hero-para font-weight-semibold no-br">
                                <Trans>
                                    Join the campaign now and earn with every
                                    step you take.
                                </Trans>
                            </p>
                            <div className="pl-0 pr-0 col-12 mt-4 d-flex justify-content-center align-items-center">
                                <a
                                    href={t(`/request-demo/`)}
                                    className="vfitcompanycta arrowbtn-img"
                                >
                                    <Trans>Book a Demo</Trans>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AppDownload;
